module.exports = __webpack_public_path__ + "media/images/logo/ketentest-6cbcb8ab1417cbb183049c81422b3932.png";